import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { UserNotifyService } from 'src/app/core/notify/user-notify.service';
import { GetNotBoughtExamTypeCountModel } from 'src/app/shared/api-models/responses/exam/GetNotBoughtExamTypeCountModel';
import { GetUserBoughtExamsModel } from 'src/app/shared/api-models/responses/exam/GetUserBoughtExamsModel';
import { GetUserNotBoughtExamsCountService } from 'src/app/shared/services/api/exam/get_not_bought_exams_count.service';
import { GetNotBoughtExamTypeCountService } from 'src/app/shared/services/api/exam/get_not_bought_exam_type_count.service';
import { GetUserBoughtExamsService } from 'src/app/shared/services/api/exam/get_user_bought_exams.service';
import * as fromApp from '../../../../ngrx/app.reducer';
import { LoginBottomSheetComponent } from '../../auth/login-bottom-sheet/login-bottom-sheet.component';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss']
})
export class ExamComponent implements OnInit, OnDestroy {
  toggleShowExamMe = true;
  notBoughtCount = 0;
  totalBoughtCount = 0;
  totalAllBoughtCount = 0;
  totalMicroscopicCount = 0;
  boughtExams: GetUserBoughtExamsModel[] = [];
  unsubscribes: Subscription[] = [];
  notBoughtExamTypes: GetNotBoughtExamTypeCountModel = {
    all_in_one_count: 0,
    microscopic_count: 0
  }
  bottomSheet: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private getUserNotBoughtExams: GetUserNotBoughtExamsCountService,
    private getUserBoughtExams: GetUserBoughtExamsService,
    private store: Store<fromApp.AppState>,
    private getNotBoughtExamTypesCount: GetNotBoughtExamTypeCountService,
    private userNotify: UserNotifyService
  ) {
  }

  ngOnInit(): void {


  }

  changeRoute(route: string | number) {
    this.router.navigate([route.toString()], { relativeTo: this.route })
  }
  changeRouteMy(route: string | number) {
    this.router.navigate(['my/' + route.toString()], { relativeTo: this.route })
  }

  ngOnDestroy() {
    this.unsubscribes.forEach(x => x.unsubscribe());
  }

  comingSoon() {
    this.userNotify.showInfo('به زودی')
  }


}
